module.exports = __webpack_public_path__ + "static/media/img-market-product-bg.ad3dd1a7.svg";